import { useEffect, useRef, useState } from 'react'
import { canSpeak, isMuted, onMuteChange, speak, stopSpeaking } from '../lib/speech.js'
import { track } from '../lib/analytics.js'
import { registerReader } from '../lib/hotkey.js'

/**
 * Read-aloud button on its own, for places with no single text block to
 * highlight (headings, quiz questions, the reveal). Text blocks use ReadAloud.
 * Like ReadAloud, it answers the space bar while mounted (D-112).
 */
export default function Speaker({ text, auto = false, label = 'Read it to me', size = 'md' }) {
  const [busy, setBusy] = useState(false)
  const [muted, setMutedState] = useState(isMuted())
  useEffect(() => onMuteChange(setMutedState), [])

  useEffect(() => {
    if (!auto || !canSpeak() || !text || isMuted()) return
    let live = true
    setBusy(true)
    speak(text).then(() => live && setBusy(false))
    return () => {
      live = false
      stopSpeaking()
    }
  }, [auto, text])

  const onTap = async (via = 'tap') => {
    if (busy) {
      stopSpeaking()
      setBusy(false)
      return
    }
    track('readaloud_tap', { via })
    setBusy(true)
    await speak(text)
    setBusy(false)
  }
  const latest = useRef(onTap)
  latest.current = onTap
  useEffect(() => registerReader((via) => latest.current(via)), [])

  if (!canSpeak() || muted) return null
  return (
    <button className={`speaker speaker--${size}${busy ? ' speaker--busy' : ''}`} onClick={onTap} aria-label={busy ? 'Stop reading' : label}>
      <span aria-hidden="true">{busy ? '◼' : '🔊'}</span>
    </button>
  )
}
